__turbopack_context__.v({
  "item": "InsightItem-module__VwGmeG__item",
  "itemLabel": "InsightItem-module__VwGmeG__itemLabel",
  "itemValue": "InsightItem-module__VwGmeG__itemValue",
  "itemValueClickable": "InsightItem-module__VwGmeG__itemValueClickable",
  "tooltipOverride": "InsightItem-module__VwGmeG__tooltipOverride",
  "tooltipValueOverride": "InsightItem-module__VwGmeG__tooltipValueOverride",
});
